import { render } from "./EditVehicleRoute.vue?vue&type=template&id=4590dadd"
import script from "./EditVehicleRoute.vue?vue&type=script&lang=js"
export * from "./EditVehicleRoute.vue?vue&type=script&lang=js"
script.render = render

export default script